import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { Typography } from "antd";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const { Text } = Typography;
const COLOMBIA_CENTER = [4.5709, -74.2973];

const isValidPos = (pos) => {
  if (!Array.isArray(pos) || pos.length < 2) return false;
  const lat = parseFloat(pos[0]);
  const lng = parseFloat(pos[1]);
  return !Number.isNaN(lat) && !Number.isNaN(lng) && isFinite(lat) && isFinite(lng);
};

const toPosition = (val) => {
  if (!isValidPos(val)) return null;
  return [parseFloat(val[0]), parseFloat(val[1])];
};

function ClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      onSelect([e.latlng.lat, e.latlng.lng]);
    },
  });
  return null;
}

export default function MapSelector({ value, onChange }) {
  const [position, setPosition] = useState(() => toPosition(value));
  // mapKey forces MapContainer remount only when an external value arrives,
  // so the map centers correctly without any flyTo animation.
  const [mapKey, setMapKey] = useState("init");

  const valueStr = JSON.stringify(value);
  useEffect(() => {
    const coords = valueStr ? JSON.parse(valueStr) : null;
    const next = toPosition(coords);
    if (next) {
      setPosition(next);
      setMapKey(`${next[0]}-${next[1]}`);
    }
  }, [valueStr]);

  const handleSelect = (coords) => {
    setPosition(coords);
    if (onChange) onChange(coords);
  };

  const center = isValidPos(position) ? position : COLOMBIA_CENTER;
  const zoom = isValidPos(position) ? 15 : 6;

  return (
    <div>
      <div
        style={{
          height: 320,
          borderRadius: 8,
          overflow: "hidden",
          border: "1px solid #d9d9d9",
          cursor: "crosshair",
        }}
      >
        <MapContainer
          key={mapKey}
          center={center}
          zoom={zoom}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <ClickHandler onSelect={handleSelect} />
          {isValidPos(position) && <Marker position={position} />}
        </MapContainer>
      </div>
      {isValidPos(position) && (
        <div style={{ marginTop: 8, display: "flex", gap: 24 }}>
          <Text type="secondary">
            Lat: <Text strong>{parseFloat(position[0]).toFixed(6)}</Text>
          </Text>
          <Text type="secondary">
            Lng: <Text strong>{parseFloat(position[1]).toFixed(6)}</Text>
          </Text>
        </div>
      )}
    </div>
  );
}
